import { Typography as AntTypography } from 'antd';
import React, { memo } from 'react';

import { skyBlue } from 'style/colour-palette';

type AntLinkProps = React.ComponentProps<typeof AntTypography.Link>;

type TypographyLinkProps = Pick<
  AntLinkProps,
  | 'children'
  | 'id'
  | 'onClick'
  | 'target'
  | 'underline'
> & {
  href: string;
  /** `inherit`: match parent text color. `darkSurface`: sky-blue for dark backgrounds (tooltips, banners). */
  customColor?: 'inherit' | 'darkSurface';
  /** Only used by NewTabLink. Applies internal-admin link styling (pink). */
  internalAdmin?: boolean;
  /** Only used by NewTabLink. */
  disabled?: boolean;
};

function TypographyLink(props: TypographyLinkProps): JSX.Element {
  const { customColor, internalAdmin, target, ...rest } = props;
  const resolvedClassName = internalAdmin ? 'internal-admin' : undefined;
  const resolvedStyle =
    customColor === 'inherit'
      ? { color: 'inherit' as const }
      : customColor === 'darkSurface'
        ? { color: skyBlue }
        : undefined;
  const resolvedRel = target === '_blank' ? 'noopener noreferrer' : undefined;
  return (
    <AntTypography.Link
      {...rest}
      className={resolvedClassName}
      rel={resolvedRel}
      style={resolvedStyle}
      target={target}
    />
  );
}

export default memo(TypographyLink);
export type { TypographyLinkProps };
